import classNames from "classnames";
import { getIn } from "formik";

export const appendValidationClassNames = (
  currentClass,
  touched,
  errors,
  fieldName
) =>
  classNames(currentClass, {
    error: getIn(touched, fieldName) && getIn(errors, fieldName),
    touched: getIn(touched, fieldName)
  });
